export const BRIEFING_GENERATION_POLLING_TIMEOUT_MS = 120_000;
